import { inject as injector } from './registrable'

var form_control_uid_generator = 0

export default {

  mixins: [ injector('form', 'form-control', '<n-form>', false) ],

  props: {
    value: { required: true },
    forceFloatLabel: { type: Boolean },
    collapseEmptyContent: { type: Boolean },
    label: String,
  },

  data () {
    return {
      control_id: `control-${form_control_uid_generator++}`,
      control_value: this.value,
      isFocused: false,
    }
  },

  computed: {
    classes() {
      return Object.assign({
        'has-value': this.hasValue,
        'float-label': this.floatLabel,
        'is-disabled': this.$attrs.disabled !== undefined && this.$attrs.disabled !== false,
        'no-label': this.label == null,
        'collapse-empty-additional-content': this.collapseEmptyContent,
      }, this.validation_classes || {})
    },

    floatLabel() {
      return this.forceFloatLabel || this.controlHasShadowUI || this.hasValue || this.isFocused || this.isMultipleSelect
    },

    hasValue() {
      return this.control_value !== undefined && this.control_value !== null && this.control_value !== ''
    },

    _placeholder() {
      return this.isFocused && !this.hasValue ? this.$attrs.placeholder : null
    },
  },

  created() {
    this.form.register(this)
  },

  watch: {
    value: function(newVal, oldVal) {
      this.control_value = newVal
    },

    control_value: function(val) {
      this.$emit('input', val)
    }
  },

  methods: {
    focus() {
      return this.$refs.controlEl.focus()
    },

    blur() {
      return this.$refs.controlEl.blur()
    },

    fcOnFocus(e) {
      this.isFocused = true
      return this.$emit('focus', e)
    },

    fcOnBlur(e) {
      this.isFocused = false
      return this.$emit('blur', e)
    },
  },

  beforeDestroy () {
    this.form.unregister(this)
  },
}